<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="02" :question="question"></QuestionTitle>
        <div class="container-70">
            <InputBox :img="imgEvenement" :inputInfo="inputInfo" textAlign="end" v-model="result"></InputBox>
            <div v-if="result!=null" @click="saveAndContinue('evenementNbParticipants', JSON.stringify(result), './question-3')" class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine percent="25%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import InputBox from '@/components/InputBox.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Combien y’a-t-il de personnes présentes pendant toute la durée de votre évènement? ',
            imgEvenement:require('@/assets/images/party.png'),
            inputInfo:{
                label:'participants(e)s, employés(e)s, artistes, etc.'
            },
        }
    },
    components: {
        QuestionTitle,
        InputBox,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('evenementNbParticipants')){
            this.result=JSON.parse(sessionStorage.getItem('evenementNbParticipants'))
        }
    }
}
</script>